import React from 'react';
import Badge from '../../atoms/badge/Badge';

interface progressBadgeProps {
  progress: number;
}

function identifyRightBadgeType(range: number) {
  if (range >= 0 && range <= 20) {
    return 'danger';
  } else if (range >= 21 && range <= 79) {
    return 'warning';
  } else if (range >= 80 && range <= 100) {
    return 'success';
  } else {
    return 'default';
  }
}

const ProgressBadge = ({ progress }: progressBadgeProps) => {
  return (
    <Badge
      label={`${progress.toString()}%`}
      type={identifyRightBadgeType(progress)}
    />
  );
};

export default ProgressBadge;
